import styles from './apiRank.module.scss';
import classNames from 'classnames';
// import { Select } from 'antd';
import { useEffect, useState } from 'react';
// import * as echarts from 'echarts';
import { interfaceRank } from "@/apis/statistics"
import { FireFilled } from '@ant-design/icons';

const ApiRank = () => {
	const [list, setList] = useState([]);
	const getList = () => {
		interfaceRank().then(res => {
			setList(res?.data || [])
		})
	}
	useEffect(() => {
		getList()
	}, []);
	return <div className={styles.apiRankBox}>
		{list.map((item, index) => {
			return <div className={classNames('flex_box', 'flex_between', styles.rankBox, index < 3 && styles.bigBox)} key={'rank_' + index}>
				<span><i>{index + 1}</i>{item.interfaceUrl}</span>
				<span><i>{item.accessTimes}</i>{index < 3 && <FireFilled />}</span>
			</div>
		})}
	</div>
}
export default ApiRank;